export default {"src":"/_next/static/media/lab_placeholder.18bd1897.svg","height":144,"width":256,"blurWidth":0,"blurHeight":0};